var _defs, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNumpy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #4d77cf;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #4dabcf;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M472.31114,253.92323l-161.03752-81.28716-176.73145,88.20274,165.39178,83.05679,172.37719-89.97237Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M546.1239,291.17887l168.83793,85.22226-175.17139,87.96988-165.64789-83.19649,171.98136-89.99564Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M771.61366,173.87018l173.44827,86.96863-155.12316,77.91088-169.18719-85.33871,150.86208-79.5408Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M696.96268,136.40496l-156.1477-78.28341-154.47119,77.0726,160.89781,81.14744,149.72108-79.93662Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M574.88062,808.79944v213.07901l189.1655-94.3965-.20955-213.17216-188.95594,94.48966Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M763.7667,639.91497l-.20955-210.93678-188.67654,93.79107v211.00663l188.88609-93.86093Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M990.86312,600.37739v213.91722l-161.34023,80.51879-.1164-212.9393,161.45663-81.49672Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M990.86312,525.5867v-209.60953l-161.64287,80.35575.1397,211.35592,161.50317-82.10214Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M508.09986,522.76927l-127.4143-64.05641v276.87924s-155.82172-331.55192-170.25829-361.33313c-1.86279-3.84197-9.52348-8.05655-11.4794-9.08105-27.94173-14.66942-109.811-56.1396-109.811-56.1396v489.16657l113.25714,60.54042v-255.69012s154.16852,296.25223,155.72856,299.48877,17.04447,34.46144,33.57664,45.42862c22.02741,14.57629,116.42388,71.34459,116.42388,71.34459l-.02324-496.54791Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumpy);
export default __webpack_public_path__ + "static/media/numpy.f8b7065e79806dcb8fadc1381f3a18cb.svg";
export { ForwardRef as ReactComponent };